<template>
<v-container>
  <v-card>
    <v-card-title>
      <strong>Stati corrispondenti</strong>
      <v-btn fab dark small color="#4EABDD" @click="insertNewRecord()">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
      <template slot="items" slot-scope="props">
        <tr @click="updateRecord(props.item.codiceCorris, props.item.statusCorris)">
          <td class="text-xs-left">{{ props.item.codiceCorris }}</td>
          <td class="text-xs-left">{{ props.item.statusCorris }}</td>
          <td class="text-xs-left">{{ props.item.statusArco }}</td>
          <td class="text-xs-left">{{ props.item.descrizione }}</td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
  </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tmp: "",
      search: "",
      pagination: {},
      headers: [
        { text: "Codice corrispondente", align: "left", value: "codiceCorris" },
        { text: "Stato corrispondente", align: "left", value: "statusCorris" },
        { text: "Stato Arco", align: "left", value: "statusArco" },
        { text: "Descrizione", align: "left", value: "descrizione" },
      ],
      items: []
    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.CheckJWT();
    this.getDataFromService();
  },
  methods: {
    getDataFromService() {
      this.loading = true;
      axios.get(this.$store.state.servicePath + "/api/ArStatiCorrispondentis").then(res => {
        this.items = res.data;
        //console.log(this.items)
        this.loading = false;
      });
    },

    insertNewRecord() {
      this.$router.push({ path: `/staticorrispondenti/0/0` });
    },

    updateRecord(codiceCorris, statusCorris) {
      this.$router.push({ path: `/staticorrispondenti/${codiceCorris}/${statusCorris}` });
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>